/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useEmailTestPageStyles = makeStyles(() => ({
  title: {
    marginTop: '5px',
    marginBottom: '20px',
  },
  submitBtn: {
    marginTop: '20px',
  },
  modalError: {
    textAlign: 'left',
    whiteSpace: 'pre-wrap',
  },
}));
